export function makeOtherBoItems(data) {
    const bo = data?.dispatch ?? {};

    return [
        {
            label: "",
            value: bo?.otheroccurrencenumber ?? "",
        },
    ];
}